export const removeEmptyParagraphs = (htmlString) => {
  if (!htmlString) return htmlString;

  // Remove paragraphs that contain only whitespace, &nbsp;, or empty spans
  return htmlString
    .replace(/<p[^>]*>[\s]*<span[^>]*>[\s&nbsp;]*<\/span>[\s]*<\/p>/gi, '')
    .replace(/<p[^>]*>[\s&nbsp;]*<\/p>/gi, '')
    .replace(/<p[^>]*><span[^>]*>[\s&nbsp;]*<\/span>[\s]*<\/p>/gi, '');
};
